import React from "react";

/* ------------------------------------------------------------------ */
/*  Abnormal Illustrations                                             */
/*  Poster-quality artwork provided by the brand owner.                */
/*  These are transparent PNGs — they sit directly on the site's black */
/*  background with no paper mount required.                           */
/* ------------------------------------------------------------------ */

const ASSETS = {
    // Geometric black line-art brain
    brainLine:    "https://customer-assets-lqy194kg.emergentagent.net/job_argentario-enduro/artifacts/rrfx6knc_C578DAC1-D376-4008-B97C-B71783308CCA.png",
    // Purple brain flower "GROW DIFFERENT."
    brainFlower:  "https://customer-assets-lqy194kg.emergentagent.net/job_argentario-enduro/artifacts/833kmi6m_1A47F308-DAE3-4608-8B2F-B52F934CC5AA.png",
    // UFO abducting brains "NORMALS GET LEFT BEHIND"
    escapeHerd:   "https://customer-assets-lqy194kg.emergentagent.net/job_argentario-enduro/artifacts/c8fcu90x_8CD3D362-6AE4-4E7E-B8EE-4A9EC03689FD.png",
    // Wall of Thoughts poster (jars + manifesto)
    wallThoughts: "https://customer-assets-lqy194kg.emergentagent.net/job_argentario-enduro/artifacts/k8dojovx_DBB8EB04-D019-4BE8-A9C4-F974C171B0F8.png",
    // NEW · Purple brain w/ green mohawk + "ABNORMAL" drippy wordmark
    brainMohawk:  "https://customer-assets-lqy194kg.emergentagent.net/job_argentario-enduro/artifacts/wb43ya38_7EEE065C-2303-4944-BF7D-5CDBF25C123A.png",
};

/* Transparent poster renderer. Optionally inverts pure-black artwork to
 * white so it reads on the site's black background.
 */
function Poster({ src, size = 200, alt, className = "", tilt = 0, invert = false }) {
    const style = {
        width: size,
        height: "auto",
        transform: tilt ? `rotate(${tilt}deg)` : undefined,
        filter: invert ? "invert(1)" : undefined,
    };
    return (
        <img
            src={src}
            alt={alt}
            width={size}
            style={style}
            loading="lazy"
            decoding="async"
            className={`inline-block select-none pointer-events-none ${className}`}
        />
    );
}

/* 01 · BRAIN IN A JAR → geometric ABNORMAL brain outline (inverted → white). */
export function BrainInJar({ size = 220, className = "", tilt = 0 }) {
    return <Poster src={ASSETS.brainLine} size={size} tilt={tilt} invert alt="Abnormal brain mark" className={className} />;
}

/* 02 · BRAIN FLOWER → "GROW DIFFERENT." brand poster (colored, no invert). */
export function BrainFlower({ size = 220, className = "", tilt = 0 }) {
    return <Poster src={ASSETS.brainFlower} size={size} tilt={tilt} alt="Grow different" className={className} />;
}

/* 03 · ESCAPE THE HERD → "Normals get left behind" UFO poster (inverted → white). */
export function EscapeTheHerd({ size = 240, className = "", tilt = 0 }) {
    return <Poster src={ASSETS.escapeHerd} size={size} tilt={tilt} invert alt="Normals get left behind" className={className} />;
}

/* 04 · SKULL ENDURO → falls back to the mohawk mark. */
export function SkullEnduro({ size = 220, className = "", tilt = 0 }) {
    return <Poster src={ASSETS.brainMohawk} size={size} tilt={tilt} alt="Abnormal" className={className} />;
}

/* 05 · WALL OF THOUGHTS → colored jars poster. */
export function WallOfThoughts({ size = 260, className = "", tilt = 0 }) {
    return <Poster src={ASSETS.wallThoughts} size={size} tilt={tilt} alt="Wall of Thoughts — every thought deserves a place" className={className} />;
}

/* 06 · ABNORMAL BRAIN MOHAWK — the new brand mark. */
export function AbnormalBrainMark({ size = 240, className = "", tilt = 0 }) {
    return <Poster src={ASSETS.brainMohawk} size={size} tilt={tilt} alt="Abnormal" className={className} />;
}

/* Alias for older imports. */
export function AbnormalWordmark({ size = 200, className = "", tilt = 0 }) {
    return <Poster src={ASSETS.brainMohawk} size={size} tilt={tilt} alt="Abnormal" className={className} />;
}

export const ABNORMAL_ASSETS = ASSETS;
